import "./sdk.gen-B9KhOqm6.js";
//#region src/generated/types.gen.ts
var e = { VASCO: "VASCO" }, t = { STATUS: "status" }, n = {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE"
}, r = {
	ASC: "ASC",
	DESC: "DESC"
}, i = {
	SalesChannelStatusChanged: "SalesChannelStatusChanged",
	ProductCreated: "ProductCreated",
	ProductUpdated: "ProductUpdated",
	OrderCreated: "OrderCreated",
	OrderDeleted: "OrderDeleted",
	OrderRulesEvaluated: "OrderRulesEvaluated",
	OrderUpdated: "OrderUpdated",
	Printed: "Printed",
	PrintErrored: "PrintErrored"
}, a = {
	Account: "account",
	Shop: "shop",
	Order: "ORDER",
	Product: "PRODUCT",
	Print: "PRINT"
}, o = {
	Event: "Event",
	Order: "Order",
	Printing: "Printing",
	Product: "Product"
};
//#endregion
//#region ../../node_modules/.pnpm/@vue+shared@3.5.40/node_modules/@vue/shared/dist/shared.esm-bundler.js
// @__NO_SIDE_EFFECTS__
function s(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var c = process.env.NODE_ENV === "production" ? {} : Object.freeze({});
process.env.NODE_ENV === "production" || Object.freeze([]);
var l = () => {}, u = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), d = (e) => e.startsWith("onUpdate:"), f = Object.assign, p = (e, t) => {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}, m = Object.prototype.hasOwnProperty, h = (e, t) => m.call(e, t), g = Array.isArray, _ = (e) => C(e) === "[object Map]", v = (e) => C(e) === "[object Set]", y = (e) => typeof e == "function", b = (e) => typeof e == "string", ee = (e) => typeof e == "symbol", x = (e) => typeof e == "object" && !!e, te = (e) => (x(e) || y(e)) && y(e.then) && y(e.catch), S = Object.prototype.toString, C = (e) => S.call(e), ne = (e) => C(e).slice(8, -1), re = (e) => C(e) === "[object Object]", ie = (e) => b(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, ae = ((e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
})((e) => e.charAt(0).toUpperCase() + e.slice(1)), oe = (e, t) => !Object.is(e, t), se = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, ce, le = () => ce ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function ue(e) {
	if (g(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = b(r) ? me(r) : ue(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	} else if (b(e) || x(e)) return e;
}
var de = /;(?![^(]*\))/g, fe = /:([^]+)/, pe = /\/\*[^]*?\*\//g;
function me(e) {
	let t = {};
	return e.replace(pe, "").split(de).forEach((e) => {
		if (e) {
			let n = e.split(fe);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function he(e) {
	let t = "";
	if (b(e)) t = e;
	else if (g(e)) for (let n = 0; n < e.length; n++) {
		let r = he(e[n]);
		r && (t += r + " ");
	}
	else if (x(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+reactivity@3.5.40/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function ge(e, ...t) {
	console.warn(`[Vue warn] ${e}`, ...t);
}
var _e;
function ve() {
	return _e;
}
var w, ye = /* @__PURE__ */ new WeakSet(), be = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, _e && (_e.active ? _e.effects.push(this) : this.flags &= -2);
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, ye.has(this) && (ye.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || we(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, Ie(this), De(this);
		let e = w, t = T;
		w = this, T = !0;
		try {
			return this.fn();
		} finally {
			process.env.NODE_ENV !== "production" && w !== this && ge("Active effect was not restored correctly - this is likely a Vue internal bug."), Oe(this), w = e, T = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) je(e);
			this.deps = this.depsTail = void 0, Ie(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? ye.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		ke(this) && this.run();
	}
	get dirty() {
		return ke(this);
	}
}, xe = 0, Se, Ce;
function we(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = Ce, Ce = e;
		return;
	}
	e.next = Se, Se = e;
}
function Te() {
	xe++;
}
function Ee() {
	if (--xe > 0) return;
	if (Ce) {
		let e = Ce;
		for (Ce = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; Se;) {
		let t = Se;
		for (Se = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function De(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Oe(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), je(r), Me(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function ke(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (Ae(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function Ae(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Le) || (e.globalVersion = Le, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !ke(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = w, r = T;
	w = e, T = !0;
	try {
		De(e);
		let n = e.fn(e._value);
		(t.version === 0 || oe(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		w = n, T = r, Oe(e), e.flags &= -3;
	}
}
function je(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) je(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function Me(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
var T = !0, Ne = [];
function Pe() {
	Ne.push(T), T = !1;
}
function Fe() {
	let e = Ne.pop();
	T = e === void 0 || e;
}
function Ie(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = w;
		w = void 0;
		try {
			t();
		} finally {
			w = e;
		}
	}
}
var Le = 0, Re = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, ze = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
	}
	track(e) {
		if (!w || !T || w === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== w) t = this.activeLink = new Re(w, this), w.deps ? (t.prevDep = w.depsTail, w.depsTail.nextDep = t, w.depsTail = t) : w.deps = w.depsTail = t, Be(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = w.depsTail, t.nextDep = void 0, w.depsTail.nextDep = t, w.depsTail = t, w.deps === t && (w.deps = e);
		}
		return process.env.NODE_ENV !== "production" && w.onTrack && w.onTrack(f({ effect: w }, e)), t;
	}
	trigger(e) {
		this.version++, Le++, this.notify(e);
	}
	notify(e) {
		Te();
		try {
			if (process.env.NODE_ENV !== "production") for (let t = this.subsHead; t; t = t.nextSub) t.sub.onTrigger && !(t.sub.flags & 8) && t.sub.onTrigger(f({ effect: t.sub }, e));
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			Ee();
		}
	}
};
function Be(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) Be(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
	}
}
var Ve = /* @__PURE__ */ new WeakMap(), He = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Object iterate"), Ue = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Map keys iterate"), We = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Array iterate");
function E(e, t, n) {
	if (T && w) {
		let r = Ve.get(e);
		r || Ve.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(n);
		i || (r.set(n, i = new ze()), i.map = r, i.key = n), process.env.NODE_ENV === "production" ? i.track() : i.track({
			target: e,
			type: t,
			key: n
		});
	}
}
function Ge(e, t, n, r, i, a) {
	let o = Ve.get(e);
	if (!o) {
		Le++;
		return;
	}
	let s = (o) => {
		o && (process.env.NODE_ENV === "production" ? o.trigger() : o.trigger({
			target: e,
			type: t,
			key: n,
			newValue: r,
			oldValue: i,
			oldTarget: a
		}));
	};
	if (Te(), t === "clear") o.forEach(s);
	else {
		let i = g(e), a = i && ie(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === We || !ee(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(We)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(He)), _(e) && s(o.get(Ue)));
				break;
			case "delete":
				i || (s(o.get(He)), _(e) && s(o.get(Ue)));
				break;
			case "set":
				_(e) && s(o.get(He));
				break;
		}
	}
	Ee();
}
function Ke(e) {
	let t = /* @__PURE__ */ O(e);
	return t === e ? t : (E(t, "iterate", We), /* @__PURE__ */ D(e) ? t : t.map(Pt));
}
function qe(e) {
	return E(e = /* @__PURE__ */ O(e), "iterate", We), e;
}
function Je(e, t) {
	return /* @__PURE__ */ jt(e) ? Ft(/* @__PURE__ */ At(e) ? Pt(t) : t) : Pt(t);
}
var Ye = {
	__proto__: null,
	[Symbol.iterator]() {
		return Xe(this, Symbol.iterator, (e) => Je(this, e));
	},
	concat(...e) {
		return Ke(this).concat(...e.map((e) => g(e) ? Ke(e) : e));
	},
	entries() {
		return Xe(this, "entries", (e) => (e[1] = Je(this, e[1]), e));
	},
	every(e, t) {
		return Qe(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return Qe(this, "filter", e, t, (e) => e.map((e) => Je(this, e)), arguments);
	},
	find(e, t) {
		return Qe(this, "find", e, t, (e) => Je(this, e), arguments);
	},
	findIndex(e, t) {
		return Qe(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return Qe(this, "findLast", e, t, (e) => Je(this, e), arguments);
	},
	findLastIndex(e, t) {
		return Qe(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return Qe(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return et(this, "includes", e);
	},
	indexOf(...e) {
		return et(this, "indexOf", e);
	},
	join(e) {
		return Ke(this).join(e);
	},
	lastIndexOf(...e) {
		return et(this, "lastIndexOf", e);
	},
	map(e, t) {
		return Qe(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return tt(this, "pop");
	},
	push(...e) {
		return tt(this, "push", e);
	},
	reduce(e, ...t) {
		return $e(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return $e(this, "reduceRight", e, t);
	},
	shift() {
		return tt(this, "shift");
	},
	some(e, t) {
		return Qe(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return tt(this, "splice", e);
	},
	toReversed() {
		return Ke(this).toReversed();
	},
	toSorted(e) {
		return Ke(this).toSorted(e);
	},
	toSpliced(...e) {
		return Ke(this).toSpliced(...e);
	},
	unshift(...e) {
		return tt(this, "unshift", e);
	},
	values() {
		return Xe(this, "values", (e) => Je(this, e));
	}
};
function Xe(e, t, n) {
	let r = qe(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ D(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var Ze = Array.prototype;
function Qe(e, t, n, r, i, a) {
	let o = qe(e), s = o !== e && !/* @__PURE__ */ D(e), c = o[t];
	if (c !== Ze[t]) {
		let t = c.apply(e, a);
		return s ? Pt(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, Je(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function $e(e, t, n, r) {
	let i = qe(e), a = i !== e && !/* @__PURE__ */ D(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = Je(e, t)), n.call(this, t, Je(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? Je(e, c) : c;
}
function et(e, t, n) {
	let r = /* @__PURE__ */ O(e);
	E(r, "iterate", We);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ Mt(n[0]) ? (n[0] = /* @__PURE__ */ O(n[0]), r[t](...n)) : i;
}
function tt(e, t, n = []) {
	Pe(), Te();
	let r = (/* @__PURE__ */ O(e))[t].apply(e, n);
	return Ee(), Fe(), r;
}
var nt = /* @__PURE__ */ s("__proto__,__v_isRef,__isVue"), rt = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(ee));
function it(e) {
	ee(e) || (e = String(e));
	let t = /* @__PURE__ */ O(this);
	return E(t, "has", e), t.hasOwnProperty(e);
}
var at = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? wt : Ct : i ? St : xt).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = g(e);
		if (!r) {
			let e;
			if (a && (e = Ye[t])) return e;
			if (t === "hasOwnProperty") return it;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ k(e) ? e : n);
		if ((ee(t) ? rt.has(t) : nt(t)) || (r || E(e, "get", t), i)) return o;
		if (/* @__PURE__ */ k(o)) {
			let e = a && ie(t) ? o : o.value;
			return r && x(e) ? /* @__PURE__ */ Dt(e) : e;
		}
		return x(o) ? r ? /* @__PURE__ */ Dt(o) : /* @__PURE__ */ Et(o) : o;
	}
}, ot = class extends at {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = g(e) && ie(t);
		if (!this._isShallow) {
			let r = /* @__PURE__ */ jt(i);
			if (!/* @__PURE__ */ D(n) && !/* @__PURE__ */ jt(n) && (i = /* @__PURE__ */ O(i), n = /* @__PURE__ */ O(n)), !a && /* @__PURE__ */ k(i) && !/* @__PURE__ */ k(n)) return r ? (process.env.NODE_ENV !== "production" && ge(`Set operation on key "${String(t)}" failed: target is readonly.`, e[t]), !0) : (i.value = n, !0);
		}
		let o = a ? Number(t) < e.length : h(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ k(e) ? e : r);
		return e === /* @__PURE__ */ O(r) && s && (o ? oe(n, i) && Ge(e, "set", t, n, i) : Ge(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = h(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && Ge(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!ee(t) || !rt.has(t)) && E(e, "has", t), n;
	}
	ownKeys(e) {
		return E(e, "iterate", g(e) ? "length" : He), Reflect.ownKeys(e);
	}
}, st = class extends at {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return process.env.NODE_ENV !== "production" && ge(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
	deleteProperty(e, t) {
		return process.env.NODE_ENV !== "production" && ge(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
}, ct = /* @__PURE__ */ new ot(), lt = /* @__PURE__ */ new st(), ut = /* @__PURE__ */ new st(!0), dt = (e) => e, ft = (e) => Reflect.getPrototypeOf(e);
function pt(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ O(i), o = _(a), s = e === "entries" || e === Symbol.iterator && o, c = e === "keys" && o, l = i[e](...r), u = n ? dt : t ? Ft : Pt;
		return !t && E(a, "iterate", c ? Ue : He), f(Object.create(l), { next() {
			let { value: e, done: t } = l.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: s ? [u(e[0]), u(e[1])] : u(e),
				done: t
			};
		} });
	};
}
function mt(e) {
	return function(...t) {
		if (process.env.NODE_ENV !== "production") {
			let n = t[0] ? `on key "${t[0]}" ` : "";
			ge(`${ae(e)} operation ${n}failed: target is readonly.`, /* @__PURE__ */ O(this));
		}
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function ht(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ O(r), a = /* @__PURE__ */ O(n);
			e || (oe(n, a) && E(i, "get", n), E(i, "get", a));
			let { has: o } = ft(i), s = t ? dt : e ? Ft : Pt;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && E(/* @__PURE__ */ O(t), "iterate", He), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ O(n), i = /* @__PURE__ */ O(t);
			return e || (oe(t, i) && E(r, "has", t), E(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ O(a), s = t ? dt : e ? Ft : Pt;
			return !e && E(o, "iterate", He), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return f(n, e ? {
		add: mt("add"),
		set: mt("set"),
		delete: mt("delete"),
		clear: mt("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ O(this), r = ft(n), i = /* @__PURE__ */ O(e), a = !t && !/* @__PURE__ */ D(e) && !/* @__PURE__ */ jt(e) ? i : e;
			return r.has.call(n, a) || oe(e, a) && r.has.call(n, e) || oe(i, a) && r.has.call(n, i) || (n.add(a), Ge(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ D(n) && !/* @__PURE__ */ jt(n) && (n = /* @__PURE__ */ O(n));
			let r = /* @__PURE__ */ O(this), { has: i, get: a } = ft(r), o = i.call(r, e);
			o ? process.env.NODE_ENV !== "production" && bt(r, i, e) : (e = /* @__PURE__ */ O(e), o = i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? oe(n, s) && Ge(r, "set", e, n, s) : Ge(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ O(this), { has: n, get: r } = ft(t), i = n.call(t, e);
			i ? process.env.NODE_ENV !== "production" && bt(t, n, e) : (e = /* @__PURE__ */ O(e), i = n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && Ge(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ O(this), t = e.size !== 0, n = process.env.NODE_ENV === "production" ? void 0 : _(e) ? new Map(e) : new Set(e), r = e.clear();
			return t && Ge(e, "clear", void 0, void 0, n), r;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = pt(r, e, t);
	}), n;
}
function gt(e, t) {
	let n = ht(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(h(n, r) && r in t ? n : t, r, i);
}
var _t = { get: /* @__PURE__ */ gt(!1, !1) }, vt = { get: /* @__PURE__ */ gt(!0, !1) }, yt = { get: /* @__PURE__ */ gt(!0, !0) };
function bt(e, t, n) {
	let r = /* @__PURE__ */ O(n);
	if (r !== n && t.call(e, r)) {
		let t = ne(e);
		ge(`Reactive ${t} contains both the raw and reactive versions of the same object${t === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
	}
}
var xt = /* @__PURE__ */ new WeakMap(), St = /* @__PURE__ */ new WeakMap(), Ct = /* @__PURE__ */ new WeakMap(), wt = /* @__PURE__ */ new WeakMap();
function Tt(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function Et(e) {
	return /* @__PURE__ */ jt(e) ? e : kt(e, !1, ct, _t, xt);
}
// @__NO_SIDE_EFFECTS__
function Dt(e) {
	return kt(e, !0, lt, vt, Ct);
}
// @__NO_SIDE_EFFECTS__
function Ot(e) {
	return kt(e, !0, ut, yt, wt);
}
function kt(e, t, n, r, i) {
	if (!x(e)) return process.env.NODE_ENV !== "production" && ge(`value cannot be made ${t ? "readonly" : "reactive"}: ${String(e)}`), e;
	if (e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e)) return e;
	let a = i.get(e);
	if (a) return a;
	let o = Tt(ne(e));
	if (o === 0) return e;
	let s = new Proxy(e, o === 2 ? r : n);
	return i.set(e, s), s;
}
// @__NO_SIDE_EFFECTS__
function At(e) {
	return /* @__PURE__ */ jt(e) ? /* @__PURE__ */ At(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function jt(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function D(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function Mt(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function O(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ O(t) : e;
}
function Nt(e) {
	return !h(e, "__v_skip") && Object.isExtensible(e) && se(e, "__v_skip", !0), e;
}
var Pt = (e) => x(e) ? /* @__PURE__ */ Et(e) : e, Ft = (e) => x(e) ? /* @__PURE__ */ Dt(e) : e;
// @__NO_SIDE_EFFECTS__
function k(e) {
	return e ? e.__v_isRef === !0 : !1;
}
function It(e) {
	return /* @__PURE__ */ k(e) ? e.value : e;
}
var Lt = {
	get: (e, t, n) => t === "__v_raw" ? e : It(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ k(i) && !/* @__PURE__ */ k(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function Rt(e) {
	return /* @__PURE__ */ At(e) ? e : new Proxy(e, Lt);
}
var zt = {}, Bt = /* @__PURE__ */ new WeakMap(), Vt = void 0;
function Ht(e, t = !1, n = Vt) {
	if (n) {
		let t = Bt.get(n);
		t || Bt.set(n, t = []), t.push(e);
	} else process.env.NODE_ENV !== "production" && !t && ge("onWatcherCleanup() was called when there was no active watcher to associate with.");
}
function Ut(e, t, n = c) {
	let { immediate: r, deep: i, once: a, scheduler: o, augmentJob: s, call: u } = n, d = (e) => {
		(n.onWarn || ge)("Invalid watch source: ", e, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
	}, f = (e) => i ? e : /* @__PURE__ */ D(e) || i === !1 || i === 0 ? Wt(e, 1) : Wt(e), m, h, _, v, b = !1, ee = !1;
	if (/* @__PURE__ */ k(e) ? (h = () => e.value, b = /* @__PURE__ */ D(e)) : /* @__PURE__ */ At(e) ? (h = () => f(e), b = !0) : g(e) ? (ee = !0, b = e.some((e) => /* @__PURE__ */ At(e) || /* @__PURE__ */ D(e)), h = () => e.map((e) => {
		if (/* @__PURE__ */ k(e)) return e.value;
		if (/* @__PURE__ */ At(e)) return f(e);
		if (y(e)) return u ? u(e, 2) : e();
		process.env.NODE_ENV !== "production" && d(e);
	})) : y(e) ? h = t ? u ? () => u(e, 2) : e : () => {
		if (_) {
			Pe();
			try {
				_();
			} finally {
				Fe();
			}
		}
		let t = Vt;
		Vt = m;
		try {
			return u ? u(e, 3, [v]) : e(v);
		} finally {
			Vt = t;
		}
	} : (h = l, process.env.NODE_ENV !== "production" && d(e)), t && i) {
		let e = h, t = i === !0 ? Infinity : i;
		h = () => Wt(e(), t);
	}
	let x = ve(), te = () => {
		m.stop(), x && x.active && p(x.effects, m);
	};
	if (a && t) {
		let e = t;
		t = (...t) => {
			let n = e(...t);
			return te(), n;
		};
	}
	let S = ee ? Array(e.length).fill(zt) : zt, C = (e) => {
		if (!(!(m.flags & 1) || !m.dirty && !e)) if (t) {
			let n = m.run();
			if (e || i || b || (ee ? n.some((e, t) => oe(e, S[t])) : oe(n, S))) {
				_ && _();
				let e = Vt;
				Vt = m;
				try {
					let e = [
						n,
						S === zt ? void 0 : ee && S[0] === zt ? [] : S,
						v
					];
					S = n, u ? u(t, 3, e) : t(...e);
				} finally {
					Vt = e;
				}
			}
		} else m.run();
	};
	return s && s(C), m = new be(h), m.scheduler = o ? () => o(C, !1) : C, v = (e) => Ht(e, !1, m), _ = m.onStop = () => {
		let e = Bt.get(m);
		if (e) {
			if (u) u(e, 4);
			else for (let t of e) t();
			Bt.delete(m);
		}
	}, process.env.NODE_ENV !== "production" && (m.onTrack = n.onTrack, m.onTrigger = n.onTrigger), t ? r ? C(!0) : S = m.run() : o ? o(C.bind(null, !0), !0) : m.run(), te.pause = m.pause.bind(m), te.resume = m.resume.bind(m), te.stop = te, te;
}
function Wt(e, t = Infinity, n) {
	if (t <= 0 || !x(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ k(e)) Wt(e.value, t, n);
	else if (g(e)) for (let r = 0; r < e.length; r++) Wt(e[r], t, n);
	else if (v(e) || _(e)) e.forEach((e) => {
		Wt(e, t, n);
	});
	else if (re(e)) {
		for (let r in e) Wt(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && Wt(e[r], t, n);
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+runtime-core@3.5.40/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var Gt = [];
function Kt(e) {
	Gt.push(e);
}
function qt() {
	Gt.pop();
}
var Jt = !1;
function A(e, ...t) {
	if (Jt) return;
	Jt = !0, Pe();
	let n = Gt.length ? Gt[Gt.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = Yt();
	if (r) tn(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${Rr(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...Xt(i)), console.warn(...n);
	}
	Fe(), Jt = !1;
}
function Yt() {
	let e = Gt[Gt.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function Xt(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...Zt(e));
	}), t;
}
function Zt({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${Rr(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		...Qt(e.props),
		a
	] : [i + a];
}
function Qt(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...$t(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function $t(e, t, n) {
	return b(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ k(t) ? (t = $t(e, /* @__PURE__ */ O(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : y(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ O(t), n ? t : [`${e}=`, t]);
}
var en = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function tn(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		rn(e, t, n);
	}
}
function nn(e, t, n, r) {
	if (y(e)) {
		let i = tn(e, t, n, r);
		return i && te(i) && i.catch((e) => {
			rn(e, t, n);
		}), i;
	}
	if (g(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(nn(e[a], t, n, r));
		return i;
	} else process.env.NODE_ENV !== "production" && A(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
}
function rn(e, t, n, r = !0) {
	let i = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: o } = t && t.appContext.config || c;
	if (t) {
		let r = t.parent, i = t.proxy, o = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${n}` : en[n];
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, o) === !1) return;
			}
			r = r.parent;
		}
		if (a) {
			Pe(), tn(a, null, 10, [
				e,
				i,
				o
			]), Fe();
			return;
		}
	}
	an(e, n, i, r, o);
}
function an(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = en[t];
		if (n && Kt(n), A(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && qt(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var j = [], on = -1, sn = [], cn = null, ln = 0, un = /* @__PURE__ */ Promise.resolve(), dn = null, fn = 100;
function pn(e) {
	let t = dn || un;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function mn(e) {
	let t = on + 1, n = j.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = j[r], a = yn(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function hn(e) {
	if (!(e.flags & 1)) {
		let t = yn(e), n = j[j.length - 1];
		!n || !(e.flags & 2) && t >= yn(n) ? j.push(e) : j.splice(mn(t), 0, e), e.flags |= 1, gn();
	}
}
function gn() {
	dn ||= un.then(bn);
}
function _n(e) {
	g(e) ? sn.push(...e) : cn && e.id === -1 ? cn.splice(ln + 1, 0, e) : e.flags & 1 || (sn.push(e), e.flags |= 1), gn();
}
function vn(e) {
	if (sn.length) {
		let t = [...new Set(sn)].sort((e, t) => yn(e) - yn(t));
		if (sn.length = 0, cn) {
			cn.push(...t);
			return;
		}
		for (cn = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), ln = 0; ln < cn.length; ln++) {
			let t = cn[ln];
			process.env.NODE_ENV !== "production" && xn(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		cn = null, ln = 0;
	}
}
var yn = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function bn(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? l : (t) => xn(e, t);
	try {
		for (on = 0; on < j.length; on++) {
			let e = j[on];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), tn(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; on < j.length; on++) {
			let e = j[on];
			e && (e.flags &= -2);
		}
		on = -1, j.length = 0, vn(e), dn = null, (j.length || sn.length) && bn(e);
	}
}
function xn(e, t) {
	let n = e.get(t) || 0;
	if (n > fn) {
		let e = t.i, n = e && Lr(e.type);
		return rn(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var Sn = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (le().__VUE_HMR_RUNTIME__ = {
	createRecord: kn(wn),
	rerender: kn(En),
	reload: kn(Dn)
});
var Cn = /* @__PURE__ */ new Map();
function wn(e, t) {
	return Cn.has(e) ? !1 : (Cn.set(e, {
		initialDef: Tn(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function Tn(e) {
	return zr(e) ? e.__vccOpts : e;
}
function En(e, t) {
	let n = Cn.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, Tn(e.type).render = t), e.renderCache = [], e.job.flags & 8 || e.update();
	}));
}
function Dn(e, t) {
	let n = Cn.get(e);
	if (!n) return;
	t = Tn(t), On(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = Tn(i.type), o = Sn.get(a);
		o || (a !== n.initialDef && On(a, t), Sn.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? hn(() => {
			i.job.flags & 8 || (i.parent.update(), o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	_n(() => {
		Sn.clear();
	});
}
function On(e, t) {
	f(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function kn(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var An, jn = [];
function Mn(e, t) {
	An = e, An ? (An.enabled = !0, jn.forEach(({ event: e, args: t }) => An.emit(e, ...t)), jn = []) : typeof window < "u" && window.HTMLElement && !(window.navigator?.userAgent)?.includes("jsdom") ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((e) => {
		Mn(e, t);
	}), setTimeout(() => {
		An || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, jn = []);
	}, 3e3)) : jn = [];
}
var Nn = null, Pn = null;
function Fn(e, t, n = !1) {
	let r = kr();
	if (r || ar) {
		let i = ar ? ar._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && y(t) ? t.call(r && r.proxy) : t;
		process.env.NODE_ENV !== "production" && A(`injection "${String(e)}" not found.`);
	} else process.env.NODE_ENV !== "production" && A("inject() can only be used inside setup() or functional components.");
}
var In = /* @__PURE__ */ Symbol.for("v-scx"), Ln = () => {
	{
		let e = Fn(In);
		return e || process.env.NODE_ENV !== "production" && A("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."), e;
	}
};
function Rn(e, t, n = c) {
	let { immediate: r, deep: i, flush: a, once: o } = n;
	process.env.NODE_ENV !== "production" && !t && (r !== void 0 && A("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature."), i !== void 0 && A("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature."), o !== void 0 && A("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature."));
	let s = f({}, n);
	process.env.NODE_ENV !== "production" && (s.onWarn = A);
	let u = t && r || !t && a !== "post", d;
	if (Nr) {
		if (a === "sync") {
			let e = Ln();
			d = e.__watcherHandles ||= [];
		} else if (!u) {
			let e = () => {};
			return e.stop = l, e.resume = l, e.pause = l, e;
		}
	}
	let p = Or;
	s.call = (e, t, n) => nn(e, p, t, n);
	let m = !1;
	a === "post" ? s.scheduler = (e) => {
		cr(e, p && p.suspense);
	} : a !== "sync" && (m = !0, s.scheduler = (e, t) => {
		t ? e() : hn(e);
	}), s.augmentJob = (e) => {
		t && (e.flags |= 4), m && (e.flags |= 2, p && (e.id = p.uid, e.i = p));
	};
	let h = Ut(e, t, s);
	return Nr && (d ? d.push(h) : u && h()), h;
}
function zn(e, t, n) {
	let r = this.proxy, i = b(e) ? e.includes(".") ? Bn(r, e) : () => r[e] : e.bind(r, r), a;
	y(t) ? a = t : (a = t.handler, n = t);
	let o = jr(this), s = Rn(i, a.bind(r), n);
	return o(), s;
}
function Bn(e, t) {
	let n = t.split(".");
	return () => {
		let t = e;
		for (let e = 0; e < n.length && t; e++) t = t[n[e]];
		return t;
	};
}
var Vn = (e) => e.__isTeleport;
function Hn(e, t) {
	e.shapeFlag & 6 && e.component ? (e.transition = t, Hn(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
le().requestIdleCallback, le().cancelIdleCallback;
var Un = /* @__PURE__ */ Symbol.for("v-ndc"), Wn = (e) => e ? Mr(e) ? Pr(e) : Wn(e.parent) : null, Gn = /* @__PURE__ */ f(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ Ot(e.props),
	$attrs: (e) => process.env.NODE_ENV === "production" ? e.attrs : /* @__PURE__ */ Ot(e.attrs),
	$slots: (e) => process.env.NODE_ENV === "production" ? e.slots : /* @__PURE__ */ Ot(e.slots),
	$refs: (e) => process.env.NODE_ENV === "production" ? e.refs : /* @__PURE__ */ Ot(e.refs),
	$parent: (e) => Wn(e.parent),
	$root: (e) => Wn(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => __VUE_OPTIONS_API__ ? Xn(e) : e.type,
	$forceUpdate: (e) => e.f ||= () => {
		hn(e.update);
	},
	$nextTick: (e) => e.n ||= pn.bind(e.proxy),
	$watch: (e) => __VUE_OPTIONS_API__ ? zn.bind(e) : l
}), Kn = (e, t) => e !== c && !e.__isScriptSetup && h(e, t), qn = {
	get({ _: e }, t) {
		if (t === "__v_skip") return !0;
		let { ctx: n, setupState: r, data: i, props: a, accessCache: o, type: s, appContext: l } = e;
		if (process.env.NODE_ENV !== "production" && t === "__isVue") return !0;
		if (t[0] !== "$") {
			let e = o[t];
			if (e !== void 0) switch (e) {
				case 1: return r[t];
				case 2: return i[t];
				case 4: return n[t];
				case 3: return a[t];
			}
			else if (Kn(r, t)) return o[t] = 1, r[t];
			else if (__VUE_OPTIONS_API__ && i !== c && h(i, t)) return o[t] = 2, i[t];
			else if (h(a, t)) return o[t] = 3, a[t];
			else if (n !== c && h(n, t)) return o[t] = 4, n[t];
			else (!__VUE_OPTIONS_API__ || Yn) && (o[t] = 0);
		}
		let u = Gn[t], d, f;
		if (u) return t === "$attrs" ? (E(e.attrs, "get", ""), process.env.NODE_ENV) : process.env.NODE_ENV !== "production" && t === "$slots" && E(e, "get", t), u(e);
		if ((d = s.__cssModules) && (d = d[t])) return d;
		if (n !== c && h(n, t)) return o[t] = 4, n[t];
		if (f = l.config.globalProperties, h(f, t)) return f[t];
		process.env.NODE_ENV;
	},
	set({ _: e }, t, n) {
		let { data: r, setupState: i, ctx: a } = e;
		return Kn(i, t) ? (i[t] = n, !0) : process.env.NODE_ENV !== "production" && i.__isScriptSetup && h(i, t) ? (A(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : __VUE_OPTIONS_API__ && r !== c && h(r, t) ? (r[t] = n, !0) : h(e.props, t) ? (process.env.NODE_ENV !== "production" && A(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && A(`Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(a, t, {
			enumerable: !0,
			configurable: !0,
			value: n
		}) : a[t] = n, !0);
	},
	has({ _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: i, props: a, type: o } }, s) {
		let l;
		return !!(n[s] || __VUE_OPTIONS_API__ && e !== c && s[0] !== "$" && h(e, s) || Kn(t, s) || h(a, s) || h(r, s) || h(Gn, s) || h(i.config.globalProperties, s) || (l = o.__cssModules) && l[s]);
	},
	defineProperty(e, t, n) {
		return n.get == null ? h(n, "value") && this.set(e, t, n.value, null) : e._.accessCache[t] = 0, Reflect.defineProperty(e, t, n);
	}
};
process.env.NODE_ENV !== "production" && (qn.ownKeys = (e) => (A("Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."), Reflect.ownKeys(e)));
function Jn(e) {
	return g(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
var Yn = !0;
function Xn(e) {
	let t = e.type, { mixins: n, extends: r } = t, { mixins: i, optionsCache: a, config: { optionMergeStrategies: o } } = e.appContext, s = a.get(t), c;
	return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach((e) => Zn(c, e, o, !0)), Zn(c, t, o)), x(t) && a.set(t, c), c;
}
function Zn(e, t, n, r = !1) {
	let { mixins: i, extends: a } = t;
	a && Zn(e, a, n, !0), i && i.forEach((t) => Zn(e, t, n, !0));
	for (let i in t) if (r && i === "expose") process.env.NODE_ENV !== "production" && A("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
	else {
		let r = Qn[i] || n && n[i];
		e[i] = r ? r(e[i], t[i]) : t[i];
	}
	return e;
}
var Qn = {
	data: $n,
	props: rr,
	emits: rr,
	methods: nr,
	computed: nr,
	beforeCreate: M,
	created: M,
	beforeMount: M,
	mounted: M,
	beforeUpdate: M,
	updated: M,
	beforeDestroy: M,
	beforeUnmount: M,
	destroyed: M,
	unmounted: M,
	activated: M,
	deactivated: M,
	errorCaptured: M,
	serverPrefetch: M,
	components: nr,
	directives: nr,
	watch: ir,
	provide: $n,
	inject: er
};
function $n(e, t) {
	return t ? e ? function() {
		return f(y(e) ? e.call(this, this) : e, y(t) ? t.call(this, this) : t);
	} : t : e;
}
function er(e, t) {
	return nr(tr(e), tr(t));
}
function tr(e) {
	if (g(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
		return t;
	}
	return e;
}
function M(e, t) {
	return e ? [...new Set([].concat(e, t))] : t;
}
function nr(e, t) {
	return e ? f(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function rr(e, t) {
	return e ? g(e) && g(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : f(/* @__PURE__ */ Object.create(null), Jn(e), Jn(t ?? {})) : t;
}
function ir(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = f(/* @__PURE__ */ Object.create(null), e);
	for (let r in t) n[r] = M(e[r], t[r]);
	return n;
}
var ar = null, or = {}, sr = (e) => Object.getPrototypeOf(e) === or, cr = ur, lr = (e) => e.__isSuspense;
function ur(e, t) {
	t && t.pendingBranch ? g(e) ? t.effects.push(...e) : t.effects.push(e) : _n(e);
}
var dr = /* @__PURE__ */ Symbol.for("v-fgt"), fr = /* @__PURE__ */ Symbol.for("v-txt"), pr = /* @__PURE__ */ Symbol.for("v-cmt");
function mr(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
var hr, gr = (...e) => xr(...hr ? hr(e, Nn) : e), _r = ({ key: e }) => e ?? null, vr = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : b(e) || /* @__PURE__ */ k(e) || y(e) ? {
	i: Nn,
	r: e,
	k: t,
	f: !!n
} : e);
function yr(e, t = null, n = null, r = 0, i = null, a = e === dr ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && _r(t),
		ref: t && vr(t),
		scopeId: Pn,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: Nn
	};
	return s ? (Er(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= b(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && A("VNode created with invalid key (NaN). VNode type:", c.type), c;
}
var br = process.env.NODE_ENV === "production" ? xr : gr;
function xr(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === Un) && (process.env.NODE_ENV !== "production" && !e && A(`Invalid vnode type when creating vnode: ${e}.`), e = pr), mr(e)) {
		let r = Cr(e, t, !0);
		return n && Er(r, n), r.patchFlag = -2, r;
	}
	if (zr(e) && (e = e.__vccOpts), t) {
		t = Sr(t);
		let { class: e, style: n } = t;
		e && !b(e) && (t.class = he(e)), x(n) && (/* @__PURE__ */ Mt(n) && !g(n) && (n = f({}, n)), t.style = ue(n));
	}
	let o = b(e) ? 1 : lr(e) ? 128 : Vn(e) ? 64 : x(e) ? 4 : y(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ Mt(e) && (e = /* @__PURE__ */ O(e), A("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), yr(e, t, n, r, i, o, a, !0);
}
function Sr(e) {
	return e ? /* @__PURE__ */ Mt(e) || sr(e) ? f({}, e) : e : null;
}
function Cr(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? Dr(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && _r(l),
		ref: t && t.ref ? n && a ? g(a) ? a.concat(vr(t)) : [a, vr(t)] : vr(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && g(s) ? s.map(wr) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== dr ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && Cr(e.ssContent),
		ssFallback: e.ssFallback && Cr(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && Hn(u, c.clone(u)), u;
}
function wr(e) {
	let t = Cr(e);
	return g(e.children) && (t.children = e.children.map(wr)), t;
}
function Tr(e = " ", t = 0) {
	return br(fr, null, e, t);
}
function Er(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (g(t)) n = 16;
	else if (typeof t == "object") if (r & 65) {
		let n = t.default;
		n && (n._c && (n._d = !1), Er(e, n()), n._c && (n._d = !0));
		return;
	} else n = 32, !t._ && !sr(t) && (t._ctx = Nn);
	else if (y(t)) {
		if (r & 65) {
			Er(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: Nn
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [Tr(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function Dr(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = he([t.class, r.class]));
		else if (e === "style") t.style = ue([t.style, r.style]);
		else if (u(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(g(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !d(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
var Or = null, kr = () => Or || Nn, Ar;
{
	let e = le(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	Ar = t("__VUE_INSTANCE_SETTERS__", (e) => Or = e), t("__VUE_SSR_SETTERS__", (e) => Nr = e);
}
var jr = (e) => {
	let t = Or;
	return Ar(e), e.scope.on(), () => {
		e.scope.off(), Ar(t);
	};
};
function Mr(e) {
	return e.vnode.shapeFlag & 4;
}
var Nr = !1;
process.env.NODE_ENV;
function Pr(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(Rt(Nt(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in Gn) return Gn[n](e);
		},
		has(e, t) {
			return t in e || t in Gn;
		}
	}) : e.proxy;
}
var Fr = /(?:^|[-_])\w/g, Ir = (e) => e.replace(Fr, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function Lr(e, t = !0) {
	return y(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Rr(e, t, n = !1) {
	let r = Lr(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? Ir(r) : n ? "App" : "Anonymous";
}
function zr(e) {
	return y(e) && "__vccOpts" in e;
}
function Br() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, i = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!x(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ k(t)) {
				Pe();
				let n = t.value;
				return Fe(), [
					"div",
					{},
					[
						"span",
						e,
						d(t)
					],
					"<",
					s(n),
					">"
				];
			} else if (/* @__PURE__ */ At(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ D(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				s(t),
				`>${/* @__PURE__ */ jt(t) ? " (readonly)" : ""}`
			];
			else if (/* @__PURE__ */ jt(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ D(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				s(t),
				">"
			];
			return null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...a(e.$)
			];
		}
	};
	function a(e) {
		let t = [];
		e.type.props && e.props && t.push(o("props", /* @__PURE__ */ O(e.props))), e.setupState !== c && t.push(o("setup", e.setupState)), e.data !== c && t.push(o("data", /* @__PURE__ */ O(e.data)));
		let n = l(e, "computed");
		n && t.push(o("computed", n));
		let i = l(e, "inject");
		return i && t.push(o("injected", i)), t.push([
			"div",
			{},
			[
				"span",
				{ style: r.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), t;
	}
	function o(e, t) {
		return t = f({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						r,
						e + ": "
					],
					s(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function s(e, i = !0) {
		return typeof e == "number" ? [
			"span",
			t,
			e
		] : typeof e == "string" ? [
			"span",
			n,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			r,
			e
		] : x(e) ? ["object", { object: i ? /* @__PURE__ */ O(e) : e }] : [
			"span",
			n,
			String(e)
		];
	}
	function l(e, t) {
		let n = e.type;
		if (y(n)) return;
		let r = {};
		for (let i in e.ctx) u(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function u(e, t, n) {
		let r = e[n];
		if (g(r) && r.includes(t) || x(r) && t in r || e.extends && u(e.extends, t, n) || e.mixins && e.mixins.some((e) => u(e, t, n))) return !0;
	}
	function d(e) {
		return /* @__PURE__ */ D(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(i) : window.devtoolsFormatters = [i];
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
//#endregion
//#region ../../node_modules/.pnpm/vue@3.5.40_typescript@6.0.3/node_modules/vue/dist/vue.runtime.esm-bundler.js
function Vr() {
	Br();
}
process.env.NODE_ENV !== "production" && Vr();
//#endregion
//#region ../../libs/utils/dist/index.js
var Hr = Object.create, Ur = Object.defineProperty, Wr = Object.getOwnPropertyDescriptor, Gr = Object.getOwnPropertyNames, Kr = Object.getPrototypeOf, qr = Object.prototype.hasOwnProperty, Jr = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Yr = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Gr(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !qr.call(e, s) && s !== n && Ur(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Wr(t, s)) || r.enumerable
	});
	return e;
}, Xr = (e, t, n) => (n = e == null ? {} : Hr(Kr(e)), Yr(t || !e || !e.__esModule ? Ur(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), N = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, P = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
N.Dhl, N.Instabox, N.PostNl, P.PostNl, N.Bpost, P.Bpost, N.CheapCargo, P.CheapCargo, N.Dpd, P.Dpd, N.Instabox, P.Instabox, N.Dhl, P.Dhl, N.Bol, P.Bol, N.Ups, P.Ups, N.DhlForYou, P.DhlForYou, N.DhlParcelConnect, P.DhlParcelConnect, N.DhlEuroPlus, P.DhlEuroPlus, N.UpsStandard, P.UpsStandard, N.UpsExpressSaver, P.UpsExpressSaver, N.Gls, P.Gls, N.Brt, P.Brt, N.Trunkrs, P.Trunkrs, N.InPost, P.InPost, N.PosteItaliane, P.PosteItaliane, N.Spring, P.Spring, N.ViaTim, P.ViaTim, N.PostNl, P.POSTNL, N.Bpost, P.BPOST, N.CheapCargo, P.CHEAP_CARGO, N.Dpd, P.DPD, N.Instabox, P.INSTABOX, N.Dhl, P.DHL, N.Bol, P.BOL, N.Ups, P.UPS, N.DhlForYou, P.DHL_FOR_YOU, N.DhlParcelConnect, P.DHL_PARCEL_CONNECT, N.DhlEuroPlus, P.DHL_EUROPLUS, N.UpsStandard, P.UPS_STANDARD, N.UpsExpressSaver, P.UPS_EXPRESS_SAVER, N.Gls, P.GLS, N.Brt, P.BRT, N.Trunkrs, P.TRUNKRS, N.InPost, P.INPOST, N.PosteItaliane, P.POSTE_ITALIANE, N.Spring, P.SPRING, N.ViaTim, P.VIA_TIM, P.PostNl, N.PostNl, P.POSTNL, N.PostNl, P.Bpost, N.Bpost, P.BPOST, N.Bpost, P.CheapCargo, N.CheapCargo, P.CHEAP_CARGO, N.CheapCargo, P.Dpd, N.Dpd, P.DPD, N.Dpd, P.Instabox, N.Instabox, P.Dhl, N.Dhl, P.BolCom, N.Bol, P.Bol, N.Bol, P.BOL, N.Bol, P.Ups, N.Ups, P.DhlForYou, N.DhlForYou, P.DHL_FOR_YOU, N.DhlForYou, P.DhlParcelConnect, N.DhlParcelConnect, P.DHL_PARCEL_CONNECT, N.DhlParcelConnect, P.DhlEuroPlus, N.DhlEuroPlus, P.DHL_EUROPLUS, N.DhlEuroPlus, P.UpsStandard, N.UpsStandard, P.UPS_STANDARD, N.UpsStandard, P.UpsExpressSaver, N.UpsExpressSaver, P.UPS_EXPRESS_SAVER, N.UpsExpressSaver, P.Gls, N.Gls, P.GLS, N.Gls, P.Brt, N.Brt, P.BRT, N.Brt, P.Trunkrs, N.Trunkrs, P.TRUNKRS, N.Trunkrs, P.InPost, N.InPost, P.INPOST, N.InPost, P.PosteItaliane, N.PosteItaliane, P.POSTE_ITALIANE, N.PosteItaliane, P.Spring, N.Spring, P.SPRING, N.Spring, P.ViaTim, N.ViaTim, P.VIA_TIM, N.ViaTim, N.PostNl, N.Bpost, N.CheapCargo, N.Dpd, N.Instabox, N.Dhl, N.Bol, N.Ups, N.DhlForYou, N.DhlParcelConnect, N.DhlEuroPlus, N.UpsStandard, N.UpsExpressSaver, N.Gls, N.Brt, N.Trunkrs, N.InPost, N.PosteItaliane, N.ViaTim;
var F = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
F.Austria, F.Belgium, F.Bulgaria, F.Croatia, F.Cyprus, F.CzechRepublic, F.Denmark, F.Estonia, F.Finland, F.France, F.Germany, F.Greece, F.Hungary, F.Ireland, F.Italy, F.Latvia, F.Lithuania, F.Luxembourg, F.Malta, F.Netherlands, F.Poland, F.Portugal, F.Romania, F.Slovakia, F.Slovenia, F.Spain, F.Sweden, Object.values(F), F.Angola, F.AntiguaAndBarbuda, F.Aruba, F.Bahamas, F.Belize, F.Benin, F.Bermuda, F.BonaireSintEustatiusAndSaba, F.Botswana, F.BurkinaFaso, F.Burundi, F.Cameroon, F.CanaryIslands, F.CentralAfricanRepublic, F.Comoros, F.CongoBrazzaville, F.CongoKinshasa, F.CoteDIvoire, F.Curacao, F.Djibouti, F.Dominica, F.DutchAntilles, F.EquatorialGuinea, F.Eritrea, F.Fiji, F.Gabon, F.Gambia, F.Ghana, F.Grenada, F.Guyana, F.HongKong, F.Kiribati, F.KoreaPeoplesDemocraticRepublic, F.Macao, F.Malawi, F.Mali, F.Mauritania, F.Nauru, F.Qatar, F.Rwanda, F.SaintKittsAndNevis, F.SaoTomeAndPrincipe, F.Seychelles, F.SierraLeone, F.SintMaarten, F.Suriname, F.SyrianArabRepublic, F.TimorLeste, F.Togo, F.Tonga, F.Tuvalu, F.Uganda, F.UnitedArabEmirates, F.Vanuatu, F.Yemen, F.Zimbabwe, F.Austria, F.Belgium, F.Bulgaria, F.Croatia, F.CzechRepublic, F.Estonia, F.Finland, F.France, F.Germany, F.Greece, F.Hungary, F.Ireland, F.Italy, F.Latvia, F.Lithuania, F.Luxembourg, F.Malta, F.Netherlands, F.Portugal, F.Romania, F.Slovakia, F.Slovenia, F.Spain, F.UnitedKingdom, F.Denmark, F.Germany, F.Sweden;
var I = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, L = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, R = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
I.EarlyMorning, L.EarlyMorning, I.Morning, L.Morning, I.Standard, L.Standard, I.Evening, L.Evening, I.Pickup, L.Pickup, I.PickupExpress, L.PickupExpress, I.SameDayDelivery, L.SameDayDelivery, I.Express, L.Express, L.EarlyMorning, I.EarlyMorning, L.Morning, I.Morning, L.Standard, I.Standard, L.Evening, I.Evening, L.Pickup, I.Pickup, L.PickupExpress, I.PickupExpress, L.SameDayDelivery, I.SameDayDelivery, L.Express, I.Express, I.EarlyMorning, R.EarlyMorning, I.Morning, R.Morning, I.Standard, R.Standard, I.Evening, R.Evening, I.Pickup, R.Pickup, I.PickupExpress, R.PickupExpress, I.SameDayDelivery, R.SameDayDelivery, I.Express, R.Express, R.EarlyMorning, L.EarlyMorning, R.Morning, L.Morning, R.Standard, L.Standard, R.Evening, L.Evening, R.Pickup, L.Pickup, R.PickupExpress, L.PickupExpress, R.SameDayDelivery, L.SameDayDelivery, R.Express, L.Express, I.EarlyMorning, I.Morning, I.Standard, I.Evening, I.Pickup, I.PickupExpress, I.SameDayDelivery, I.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var z = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, B = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
B.Sunday, z.Sunday, B.Monday, z.Monday, B.Tuesday, z.Tuesday, B.Wednesday, z.Wednesday, B.Thursday, z.Thursday, B.Friday, z.Friday, B.Saturday, z.Saturday, z.Sunday, B.Sunday, z.Monday, B.Monday, z.Tuesday, B.Tuesday, z.Wednesday, B.Wednesday, z.Thursday, B.Thursday, z.Friday, B.Friday, z.Saturday, B.Saturday;
var Zr = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
Zr.Bytes, Zr.Kilobytes, Zr.Megabytes, Zr.Gigabytes, Zr.Terabytes;
var V = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, H = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
V.Bol, H.Bol, V.Exact, H.Exact, V.Amazon, H.Amazon, V.Wix, H.Wix, V.ExactDe, H.ExactDe, V.Etsy, H.Etsy, H.Bol, V.Bol, H.Exact, V.Exact, H.Amazon, V.Amazon, H.Wix, V.Wix, H.ExactDe, V.ExactDe, H.Etsy, V.Etsy;
var U = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, W = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
U.Unpaid, W.Unpaid, U.Due, W.Due, U.DuePrepayment, W.DuePrepayment, U.Reminder1, W.Reminder1, U.Reminder2, W.Reminder2, U.Dun, W.Dun, U.Collection, W.Collection, U.Instalments, W.Instalments, U.PaymentArrangement, W.PaymentArrangement, U.Dispute, W.Dispute, U.LegalProcedure, W.LegalProcedure, U.Insolvency, W.Insolvency, U.WriteOff, W.WriteOff, U.Pending, W.Pending, U.Cancelled, W.Cancelled, U.Paid, W.Paid, U.PaidOnline, W.PaidOnline, U.PaidAutomatic, W.PaidAutomatic, U.PaidCredit, W.PaidCredit, U.PaidZeroItems, W.PaidZeroItems, U.InvoiceWith0InvoiceItemsPaidZeroBalance, W.PaidZeroBalance, U.Due, U.Reminder1, U.Reminder2, U.Dun, U.Collection, U.Instalments, U.PaymentArrangement, U.Dispute, U.Paid, U.PaidOnline, U.PaidAutomatic, U.PaidCredit, U.PaidZeroItems;
var Qr = {
	Gram: "gram",
	Kilogram: "kilogram"
}, G = {
	Gram: "g",
	Kilogram: "kg"
}, $r = {
	[G.Gram]: 1,
	[G.Kilogram]: 1e3
}, ei = {
	Millimeter: "millimeter",
	Centimeter: "centimeter",
	Meter: "meter"
}, ti = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
}, ni = {
	[ti.Millimeter]: .1,
	[ti.Centimeter]: 1,
	[ti.Meter]: 100
}, K = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, ri = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
ri.PendingConcept, ri.PendingRegistered, ri.EnRouteHandedToCarrier, ri.EnRouteSorting, ri.EnRouteDistribution, ri.EnRouteCustoms, ri.DeliveredReadyForPickup, ri.DeliveredAtRecipient, ri.DeliveredPackagePickedUp;
var q = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, ii = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
ii.Light, q.Light, ii.Start, q.Start, ii.Plus, q.Plus, ii.Premium, q.Premium, ii.Max, q.Max, q.Light, ii.Light, q.Start, ii.Start, q.Plus, ii.Plus, q.Premium, ii.Premium, q.Max, ii.Max;
var ai = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, oi = {
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
ai.Start, oi.Start, ai.Plus, oi.Plus, ai.Premium, oi.Premium, ai.Max, oi.Max, oi.Start, ai.Start, oi.Plus, ai.Plus, oi.Premium, ai.Premium, oi.Max, ai.Max;
var si = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, ci = {
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
si.Start, ci.Start, si.Plus, ci.Plus, si.Premium, ci.Premium, si.Max, ci.Max, ci.Start, si.Start, ci.Plus, si.Plus, ci.Premium, si.Premium, ci.Max, si.Max;
var li = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, ui = {
	Light: q.Light,
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
li.Light, ui.Light, li.Start, ui.Start, li.Plus, ui.Plus, li.Premium, ui.Premium, li.Max, ui.Max, ui.Light, li.Light, ui.Start, li.Start, ui.Plus, li.Plus, ui.Premium, li.Premium, ui.Max, li.Max;
var di = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, fi = {
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
di.Start, fi.Start, di.Plus, fi.Plus, di.Premium, fi.Premium, di.Max, fi.Max, fi.Start, di.Start, fi.Plus, di.Plus, fi.Premium, di.Premium, fi.Max, di.Max;
var J = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, pi = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Y = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
J.MyParcel, pi.MyParcel, J.Flespakket, pi.Flespakket, J.SendMyParcel, pi.SendMyParcel, J.MyParcelIt, pi.MyParcelIt, J.DeliverDutch, pi.DeliverDutch, J.PostNlPlugin, pi.PostNlPlugin, J.MyParcel, Y.MyParcelNl, J.Flespakket, Y.MyParcelNl, J.SendMyParcel, Y.MyParcelBe, J.MyParcelIt, Y.MyParcelIt, J.DeliverDutch, Y.DeliverDutch, J.PostNlPlugin, Y.PostNlPlugin, Y.MyParcelNl, J.MyParcel, Y.MyParcelBe, J.SendMyParcel, Y.MyParcelIt, J.MyParcelIt, Y.MyParcelNl, K.HomeCountry, F.Netherlands, K.Eu, K.Row, F.Belgium, Y.MyParcelBe, K.HomeCountry, F.Belgium, F.Netherlands, K.Eu, K.Row, Y.MyParcelBe, K.HomeCountry, F.Belgium, K.Eu, K.Row, Y.MyParcelNl, K.HomeCountry, F.Netherlands, K.Eu, K.Row, Y.MyParcelNl, K.HomeCountry, F.Netherlands, F.Belgium, F.Luxembourg, N.Bpost, N.PostNl, N.DhlForYou, N.DhlParcelConnect, N.DhlEuroPlus, N.Ups, N.UpsStandard, N.UpsExpressSaver;
var X = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Z = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
X.Package, Z.Package, X.Mailbox, Z.Mailbox, X.Letter, Z.Letter, X.DigitalStamp, Z.DigitalStamp, X.Pallet, Z.Pallet, X.PackageSmall, Z.PackageSmall, X.Envelope, Z.Envelope, Z.Package, X.Package, Z.Mailbox, X.Mailbox, Z.Letter, X.Letter, Z.DigitalStamp, X.DigitalStamp, Z.Pallet, X.Pallet, Z.PackageSmall, X.PackageSmall, Z.Envelope, X.Envelope;
var Q = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
X.Package, Q.PACKAGE, X.Mailbox, Q.MAILBOX, X.Letter, Q.UNFRANKED, X.DigitalStamp, Q.DIGITAL_STAMP, X.Pallet, Q.PALLET, X.PackageSmall, Q.SMALL_PACKAGE, X.Envelope, Q.ENVELOPE, Q.PACKAGE, X.Package, Q.MAILBOX, X.Mailbox, Q.UNFRANKED, X.Letter, Q.DIGITAL_STAMP, X.DigitalStamp, Q.PALLET, X.Pallet, Q.SMALL_PACKAGE, X.PackageSmall, Q.ENVELOPE, X.Envelope, X.Package, X.Mailbox, X.Letter, X.DigitalStamp, X.Pallet, X.PackageSmall, X.Envelope;
var $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
$.PendingConcept, $.PendingRegistered, $.EnrouteHandedToCarrier, $.EnrouteSorting, $.EnrouteDistribution, $.DeliveredAtCustoms, $.DeliveredAtRecipient, $.DeliveredPackagePickedUp, $.DeliveredReturnShipmentPackagePickedUp, $.DeliveredAtAgreedLocation, $.PrintedLetter, $.PrintedDigitalStamp, $.InactiveConcept, $.InactiveRegistered, $.InactiveEnrouteHandedToCarrier, $.InactiveEnrouteSorting, $.InactiveEnrouteDistribution, $.InactiveEnrouteCustoms, $.InactiveDeliveredAtRecipient, $.InactiveDeliveredReadyForPickup, $.InactiveDeliveredPackagePickedUp;
var mi = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var ee = "$isDayjsObject", x = function(e) {
			return e instanceof ne || !(!e || !e[ee]);
		}, te = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, S = function(e, t) {
			if (x(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new ne(n);
		}, C = v;
		C.l = te, C.i = x, C.w = function(e, t) {
			return S(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var ne = function() {
			function g(e) {
				this.$L = te(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[ee] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (C.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return C;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = S(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return S(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < S(e);
			}, _.$g = function(e, t, n) {
				return C.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!C.u(t) || t, u = C.p(e), p = function(e, t) {
					var i = C.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return C.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = C.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[C.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = C.p(u), h = function(e) {
					var t = S(p);
					return C.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return C.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = C.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return C.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return C.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return C.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return C.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return C.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return C.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return C.s(t.$s, 2, "0");
							case "SSS": return C.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = C.p(f), _ = S(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return C.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : C.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = te(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return C.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), re = ne.prototype;
		return S.prototype = re, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			re[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), S.extend = function(e, t) {
			return e.$i ||= (e(t, ne, S), !0), S;
		}, S.locale = te, S.isDayjs = x, S.unix = function(e) {
			return S(1e3 * e);
		}, S.en = b[y], S.Ls = b, S.p = {}, S;
	}));
})), hi = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(mi()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), gi = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(mi()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_it = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), _i = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(mi()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), vi = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), yi = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, v = c || 0, y = l || 0, b = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, v, y, b + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, v, y, b)) : new Date(h, g, m, _, v, y, b);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), bi = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), xi = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), Si = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), Ci = /* @__PURE__ */ Jr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
hi(), gi(), _i();
var wi = /* @__PURE__ */ Xr(mi(), 1), Ti = /* @__PURE__ */ Xr(vi(), 1), Ei = /* @__PURE__ */ Xr(yi(), 1), Di = /* @__PURE__ */ Xr(bi(), 1), Oi = /* @__PURE__ */ Xr(xi(), 1), ki = /* @__PURE__ */ Xr(Si(), 1), Ai = /* @__PURE__ */ Xr(Ci(), 1);
wi.default.extend(Ei.default), wi.default.extend(Oi.default), wi.default.extend(Ti.default), wi.default.extend(Ai.default), wi.default.extend(Di.default), wi.default.extend(ki.default), wi.default.locale("nl"), wi.default.tz.setDefault("Europe/Amsterdam");
var ji = wi.default, Mi = (e, { locale: t = "nl-NL", currency: n = "EUR", ...r } = {}) => new Intl.NumberFormat(t, {
	style: "currency",
	currency: n,
	...r
}).format(e / 100), Ni = {
	format: Mi,
	fromMoney: (e) => e ? typeof e.micros == "number" ? e.micros / 1e4 : (e.integral ?? 0) * 100 + (e.fractional ?? 0) : 0,
	rounded: (e) => `${Mi(e, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	})},-`,
	toCents: (e) => Math.round(e * 100),
	toMoney: (e, t) => {
		let n = Math.round(e * 1e4), r = Math.floor(n / 1e4);
		return {
			currency: t ?? "EUR",
			integral: Math.floor(r / 100),
			fractional: r % 100,
			micros: n
		};
	},
	toNumberFromSegments: (e) => {
		if (!e) return 0;
		let t = e?.integral ?? 0, n = e?.fractional ?? 0;
		return t * 100 + n;
	},
	toNumberFromString: (e) => {
		let t = e?.trim() ?? "", n = Math.max(t.lastIndexOf("."), t.lastIndexOf(","));
		if (n >= 0) {
			let e = t.substring(0, n), r = t.substring(n + 1);
			return e = e.replace(/[.,]/g, ""), r.length < 2 ? r = r.padEnd(2, "0") : r.length > 2 && (r = r.substring(0, 2)), parseInt(e + r, 10);
		}
		return parseInt(t.replace(/[.,]/g, ""), 10);
	},
	toSegments: (e) => ({
		integral: Math.floor(e / 100),
		fractional: e % 100
	})
}, Pi = { toCentimeters: (e, t) => {
	switch (t) {
		case ti.Millimeter:
		case ei.Millimeter: return e * ni[ti.Millimeter];
		case ti.Centimeter:
		case ei.Centimeter: return e;
		case ti.Meter:
		case ei.Meter: return e * ni[ti.Meter];
		default: throw Error(`Unknown unit ${t}`);
	}
} }, Fi = { toBytes: (e) => {
	if (!e) return "0 b";
	let t = 1024, n = [
		"b",
		"kb",
		"mb",
		"gb"
	], r = Math.floor(Math.log(e) / Math.log(t));
	return `${Math.round(e / t ** r * 100) / 100} ${n[r]}`.replace(".", ",");
} }, Ii = {
	toCeiledDecimal: (e, t = 1) => {
		let n = 10 ** t;
		return Math.ceil(e * n) / n;
	},
	formatCompactNumber: (e) => {
		if (e < 1e3) return String(e);
		let t = e / 1e3;
		return t % 1 == 0 ? `${t}k` : `${t.toFixed(1).replace(/\.0$/, "")}k`;
	}
}, Li = { toTime: (e, t) => ji(e, "HH:mm:ss").format(t) }, Ri = { parseUrlFromDoubleSlashes: (e) => e.replace(/([^:]\/)\/+/g, "$1") }, zi = (e, t) => {
	switch (t) {
		case G.Gram:
		case Qr.Gram: return e;
		case G.Kilogram:
		case Qr.Kilogram: return e * $r[G.Kilogram];
		default: throw Error(`Unknown unit ${t}`);
	}
}, Bi = (e, t) => {
	switch (t) {
		case Qr.Gram:
		case G.Gram: return e / $r[G.Kilogram];
		case G.Kilogram:
		case Qr.Kilogram: return e;
		default: throw Error(`Unknown unit ${t}`);
	}
}, Vi = (e, t, n = { round: !0 }) => {
	if (t === Qr.Gram) return `${e}g`;
	if (t === Qr.Kilogram) return `${n.round ? Math.round(e) : e}kg`;
	throw Error(`Unknown unit ${t}`);
}, Hi = {
	currency: Ni,
	dimensions: Pi,
	weight: {
		toGrams: zi,
		toKilograms: Bi,
		toString: Vi,
		toMinMaxString: (e, t, n) => (n === Qr.Kilogram && (e = Bi(e, Qr.Gram), t = Bi(t, Qr.Gram)), `${Vi(e, n)} - ${Vi(t, n)}`)
	},
	time: Li,
	url: Ri,
	fileSize: Fi,
	number: Ii
};
function Ui(e, t, n) {
	let r = t.split(/[.[\]]/).filter(Boolean).reduce((e, t) => e?.[t], e);
	return r === void 0 ? n : r;
}
var Wi = (e, t, n) => {
	let r = t.split("."), i = r.pop(), a = /\[(\d+)\]/, o = e;
	for (let e of r) o = o[e] ??= {};
	let s = i.match(a);
	if (s) {
		let t = Number(s[1]), r = i.replace(a, "");
		return o[r] = Array.isArray(o[r]) ? o[r] : [], o[r][t] = n, e;
	}
	return o[i] = n, e;
}, Gi = (e) => ({ ...e }), Ki = (e, t) => Object.keys(e).reduce((n, r) => (t.includes(r) || (n[r] = e[r]), n), {}), qi = (e) => {
	function t(e, n, r, i = "") {
		let a = [i, n].filter((e) => e).join(".");
		return typeof r == "object" && !Array.isArray(r) ? Object.keys(r).reduce((e, n) => t(e, n, r[n], a), e) : Object.assign(e, { [a]: r });
	}
	return Object.keys(e).reduce((n, r) => t(n, r, e[r]), {});
}, Ji = (e, t) => t.reduce((t, n) => {
	let r = Ui(e, n);
	return r !== void 0 && (t[n] = r), t;
}, {}), Yi = {
	clone: Gi,
	get: Ui,
	pick: Ji,
	pickRename: (e, t) => {
		let n = Ji(e, Object.keys(t));
		return Object.entries(t).reduce((e, [t, r]) => {
			let i = n[t];
			return i !== void 0 && (e[r] = i), e;
		}, {});
	},
	flatten: qi,
	filterKeysFromObject: Ki,
	set: Wi
}, Xi = (e, t) => e.localeCompare(t), Zi = (e, t) => t.localeCompare(e), Qi = (e) => !/^[\p{L}\p{N}]/u.test(e), $i = {
	ascending: Xi,
	descending: Zi,
	byProperty: (e, t = { order: "ASC" }) => (n, r) => {
		let i = Yi.get(n, e), a = Yi.get(r, e), o = t.order === "ASC" ? Xi : Zi;
		if (!i) return t.order === "ASC" ? 1 : -1;
		if (!a) return t.order === "ASC" ? -1 : 1;
		if (t.specialCharactersLast) {
			let e = Qi(i);
			if (e !== Qi(a)) return e ? 1 : -1;
		}
		return o(i, a);
	}
}, ea = {
	byValue: (e = []) => (t, n) => {
		let r = e.indexOf(t), i = e.indexOf(n);
		return r === -1 && i === -1 ? 0 : r === -1 ? 1 : i === -1 ? -1 : r - i;
	},
	byProperty: (e, t = []) => (n, r) => {
		let i = Yi.get(n, e) ?? "", a = Yi.get(r, e) ?? "", o = t.indexOf(i), s = t.indexOf(a);
		return o === -1 && s === -1 ? 0 : o === -1 ? 1 : s === -1 ? -1 : o - s;
	}
}, ta = { sortByDate: (e, t, n = { order: "ASC" }) => e.sort((e, r) => {
	let i = ji(Yi.get(e, t)).unix(), a = ji(Yi.get(r, t)).unix();
	return n.order === "ASC" ? i - a : a - i;
}) }, na = (e, t) => e - t, ra = (e, t) => t - e, ia = {
	numeric: {
		ascending: na,
		descending: ra,
		trailingZero: (e, t) => e === 0 ? 1 : t === 0 ? -1 : e - t,
		byProperty: (e, t = { order: "ASC" }) => (n, r) => {
			let i = Yi.get(n, e), a = Yi.get(r, e);
			if (i === a) return 0;
			let o = t.order === "ASC" ? na : ra;
			return i == null ? t.order === "ASC" ? 1 : -1 : a == null ? t.order === "ASC" ? -1 : 1 : o(i, a);
		}
	},
	alphabetical: $i,
	customOrder: ea,
	date: ta
}, aa = {
	getWeightFactor: (e) => {
		switch (e) {
			case "g":
			case G.Gram:
			case Qr.Gram: return $r[G.Gram];
			case G.Kilogram:
			case Qr.Kilogram: return $r[G.Kilogram];
			default: throw Error(`Unknown weight unit: ${e}`);
		}
	},
	transformMetersToKilometers: (e) => {
		let t = e / 1e3;
		return t % 1 == 0 ? t : parseFloat(t.toFixed(1));
	}
};
//#endregion
export { o as a, t as c, i, n as l, ia as n, a as o, aa as r, e as s, Hi as t, r as u };
